import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_SE_UQ || "uq.se.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_SE_UQ || 24207,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_SE_UQ || 24208,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_SE_UQ ||
    "1:160978693362:web:aad5e70f2915b79047346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-0WYNTN42ES" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN],
  countryRegion: "Europe/stockholm",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: false
};

export default _countryEnv;
